import api from './api';
import API_CONFIG from '../config/api';

const ReportService = {
  createReport: async (reportData) => {
    try {
      const fullUrl = `${API_CONFIG.API_BASE}/reports`;
      console.log('[ReportService] Full Request URL:', fullUrl);
      console.log('[ReportService] Request Method: POST');
      console.log('[ReportService] Request Data:', reportData);
      
      const response = await api.post('/reports', reportData);
      console.log('[ReportService] Response Status:', response.status);
      console.log('[ReportService] Response Data:', response.data);
      return response.data;
    } catch (err) {
      console.error('[ReportService] Error Status:', err.response?.status);
      console.error('[ReportService] Error URL:', err.config?.url);
      console.error('[ReportService] Error Method:', err.config?.method);
      console.error('[ReportService] Error Response Data:', err.response?.data);
      console.error('[ReportService] Error Message:', err.message);
      throw err;
    }
  },

  getReports: async (params = {}) => {
    try {
      const fullUrl = `${API_CONFIG.API_BASE}/reports`;
      console.log('[ReportService] Fetching reports from:', fullUrl);
      
      const response = await api.get('/reports', { params });
      console.log('[ReportService] Reports fetched successfully:', response.data);
      return response.data;
    } catch (err) {
      console.error('[ReportService] Error fetching reports:', {
        status: err.response?.status,
        url: err.config?.url,
        data: err.response?.data,
        message: err.message
      });
      throw err;
    }
  }
};

export default ReportService;
